import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Do I have to sign a long-term contract?",
  answer: "No long-term tie-ins here. We operate on a monthly rolling basis because we're confident in the value the Silent Operator provides. We believe in keeping your business by delivering results, not by locking you into a legal contract."
}, {
  question: "Are VAT invoices provided for my business records?",
  answer: "Absolutely. We are a UK-registered entity and provide full VAT invoices for every payment made. Whether you're on our LITE or AUTHORITY tier, your accounting stays simple and professional."
}, {
  question: "How quickly can the 'Silent Operator' be active?",
  answer: "The system that sends an instant WhatsApp to your missed calls."
}, {
  question: "What happens when I miss a call on-site or at night?",
  answer: "The moment a call is missed, our AI triggers an instant, professional WhatsApp response to the caller. This secures the lead immediately, letting them know you're busy but will get back to them, preventing them from calling your competitors."
}, {
  question: "Is this system only for trades in Gloucester?",
  answer: "While we are proud to be based in Gloucester and help local firms dominate the regional map, our Silent Operator system works for tradespeople across the entire UK—from plumbers in London to gas engineers in Manchester."
}];
export default function ConsultationFaq() {
  return <section data-section-id="116954" id="uk-trade-faqs" className="bg-background py-[100px] px-4 md:px-8 text-foreground">
      <div className="mx-auto max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="font-serif text-3xl font-bold text-foreground md:text-4xl uppercase tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 font-sans text-foreground/80">
            Find answers to common questions about our Silent Operator system and how we help UK tradespeople recover lost revenue.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border border-l-4 border-l-transparent px-4 transition-colors duration-200 data-[state=open]:border-l-primary data-[state=open]:bg-card/50">
              <AccordionTrigger className="py-6 text-left font-serif text-[18px] font-bold text-foreground hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="pb-6 font-sans text-[16px] leading-relaxed text-foreground/70">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}